import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {filter, map, take} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {IAppState} from '../models/IAppState';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate, CanActivateChild {
  private isAuthorised$: Observable<boolean> = this.store.select((state) => state.AppStateReducer.isAuthorised);

  constructor(
    private store: Store<{AppStateReducer: IAppState}>,
    private router: Router
  ) {
  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isAuthorised$.pipe(
      filter(val => val !== null),
      take(1),
      map((isAuthorised: boolean) => {
        if (isAuthorised) {
          this.router.navigate(['/reservations-list'], {replaceUrl: true});
        } else {
          return true;
        }
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.canActivate();
  }

}
